import { render, staticRenderFns } from "./review-setting.pug?vue&type=template&id=c541768c&lang=pug&"
import script from "./review-setting.ts?vue&type=script&lang=ts&"
export * from "./review-setting.ts?vue&type=script&lang=ts&"
import style0 from "./review-setting.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports